import ProfilePage from './pages/ProfilePage';
import MFAVerifyPage from './pages/MFAVerifyPage';
import FirstLoginPage from './pages/FirstLoginPage';
import SettingsPage from './pages/SettingsPage';
import DeviceRegistrationsPage from './pages/DeviceRegistrationsPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import AbsencePage from './pages/AbsencePage';
import SummaryPage from './pages/SummaryPage';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import theme from './styles/theme';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';

function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress style={{ color: '#1a4d2e' }} />
    </Box>
  );
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/dashboard" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={
        <PrivateRoute><Dashboard /></PrivateRoute>
      } />
      <Route path="/admin" element={
        <PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>
      } />

      <Route path="/profile" element={
       <PrivateRoute><ProfilePage /></PrivateRoute>
      } />

      <Route path="/settings" element={
        <PrivateRoute role="admin"><SettingsPage /></PrivateRoute>
      } />

      <Route path="/mfa-verify" element={<MFAVerifyPage />} />
      <Route path="/first-login" element={
        <PrivateRoute><FirstLoginPage /></PrivateRoute>
      } />

      <Route path="/devices" element={
        <PrivateRoute role="admin"><DeviceRegistrationsPage /></PrivateRoute>
      } />
      <Route path="/announcements" element={
        <PrivateRoute><AnnouncementsPage /></PrivateRoute>
      } />
      <Route path="*" element={
        <Navigate to={user?.role === 'admin' ? '/admin' : user ? '/dashboard' : '/login'} />
      } />
      <Route path="/summary" element={
        <PrivateRoute><SummaryPage /></PrivateRoute>
      } />
      <Route path="/absence" element={
        <PrivateRoute><AbsencePage /></PrivateRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}